import React from "react";
import ChatBody from "../components/ChatBody/ChatBody";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

const Inbox = () => {
    return (
        <div>
            <Navbar />
            <div className="max-w-7xl mx-auto -mt-1">
                <div className="min-w-full border rounded flex lg:grid lg:grid-cols-3">
                    <Sidebar />
                    <ChatBody />
                </div>
            </div>
        </div>
    );
};

export default Inbox;
